import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup }                 from '@angular/forms';
import { NgForm } from '@angular/forms';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import {GlobalEventsManager} from "../_services/globaleventsmanager.service";


@Component({
  selector: 'dragdrop',
  templateUrl: 'dragdrop.template.html'
})
export class DragDropComponent  implements OnInit, OnDestroy {

  subscription: Subscription;

  constructor(private seguridad: SeguridadService,
              private router:Router,
              private globalEventsManager: GlobalEventsManager,
              private activatedRoute: ActivatedRoute){

  }

  ngOnInit(){

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode)=>{
            if (mode !== null) {
              if (!mode){
                this.router.navigate(['login']);
              }
            }
        });

    this.globalEventsManager.menuExtendido(false);

  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/dragdrop/dragdrop.component.ts